import { FC } from 'react';

import { useTranslation } from 'libs/i18n';
import { usePageTitle } from 'libs/navigation';

import { useLogin } from '../hooks';
import { LoginView } from '../views/LoginView';

export type LoginContainerProps = {};

export const LoginContainer: FC<LoginContainerProps> = () => {
  const { t } = useTranslation();

  const {
    formError,
    onSubmit,
    loading,
    isTwoFactorAuthentication,
    verificationFormError,
    onSubmitVerification,
    onBackToLogin,
  } = useLogin();

  usePageTitle(t('auth.login.pageTitle'));

  return (
    <LoginView
      formError={formError}
      isTwoFactorAuthentication={isTwoFactorAuthentication}
      loading={loading}
      verificationFormError={verificationFormError}
      onBackToLogin={onBackToLogin}
      onSubmit={onSubmit}
      onSubmitVerification={onSubmitVerification}
    />
  );
};
